export function getLogger() {
    const debug = window.location.search.indexOf('debug=true') > -1;

    return (message) => {
        if (debug || window.bbgi_debug) {
            console.log(message);
        }
    };
}